import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Message = ({ className, type, message }) => {
	const [show, setShow] = useState(false);
	useEffect(() => {
		const _showTimeout = setTimeout(() => setShow(true), 40);
		return () => clearTimeout(_showTimeout);
	}, []);

	const messageClasses = classnames("oknf-message", {
		"oknf-message--show": show,
		[`oknf-message--${type}`]: true,
	}, className);

	return (
		<span className={messageClasses}>
			{message}
		</span>
	);
};

Message.propTypes = {
	type: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired,
	className: PropTypes.string,
};

Message.defaultProps = {
	className: "",
};

export default Message;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/_Message.jsx